import React from 'react';
import { Link } from 'react-router-dom';
import { RESEARCH_SUPPORT_BASE } from '../../constants/researchSupport';

const reviewerRoles = [
  {
    title: 'Academic reviewers',
    description:
      'Subject-matter experts who evaluate methodology, argument structure, and scholarly rigor.',
  },
  {
    title: 'Publication mentors',
    description:
      'Advisors who guide journal selection, formatting, cover letters, and submission workflows.',
  },
  {
    title: 'Editorial support',
    description:
      'Specialists who help refine abstracts, keywords, and presentation for publication readiness.',
  },
];

function Reviewers() {
  return (
    <div className="space-y-8">
      <p className="text-gray-600 leading-relaxed">
        Our reviewer and mentor network supports applicants through constructive, standards-aligned
        feedback. Assignments are managed internally — applicants interact through the portal and
        official IO Fellowship communications.
      </p>

      <div className="grid md:grid-cols-3 gap-6">
        {reviewerRoles.map((role) => (
          <article
            key={role.title}
            className="bg-white border border-gray-200 rounded-lg p-6"
          >
            <h2 className="font-semibold text-iof-dark mb-2">{role.title}</h2>
            <p className="text-sm text-gray-600 leading-relaxed">{role.description}</p>
          </article>
        ))}
      </div>

      <section className="bg-white border border-gray-200 rounded-lg p-6">
        <h2 className="text-lg font-semibold text-gray-900 mb-2">Interested in becoming a reviewer?</h2>
        <p className="text-gray-600 text-sm mb-4">
          We welcome academics and postgraduate researchers with publication experience. Phase 2
          will expand self-service reviewer onboarding; for now, contact our team.
        </p>
        <Link
          to={`${RESEARCH_SUPPORT_BASE}/contact`}
          className="text-iof font-medium hover:underline"
        >
          Contact Research Support →
        </Link>
      </section>
    </div>
  );
}

export default Reviewers;
